import { invert } from 'lodash-es'
import { DocumentType } from '@apis/datastore/model'

const PDF = 'dataset/pdf.svg'
const EXCEL = 'dataset/excel.svg'
const MD = 'dataset/md.svg'
const WORD = 'dataset/word.svg'
const ZIP = 'dataset/zip.svg'
const TEXT = 'dataset/text.svg'
const BOOK = 'dataset/book.svg'
const HTML = 'dataset/html.svg'
const IMAGE = 'dataset/image.svg'
const PPT = 'dataset/ppt.svg'
const AUDIO = 'dataset/audio.svg'
const VIDEO = 'dataset/video.svg'
const EMAIL = 'dataset/email.svg'
const QAIcon = 'dataset/qa.svg'

export const fileTypeMimeMap: Record<string, string> = {
  md: 'text/markdown',
  html: 'text/html',
  htm: 'text/htm',
  txt: 'text/plain',
  css: 'text/css',
  js: 'application/javascript',
  json: 'application/json',
  xml: 'application/xml',
  jpg: 'image/jpeg',
  jpeg: 'image/jpeg',
  png: 'image/png',
  gif: 'image/gif',
  svg: 'image/svg+xml',
  pdf: 'application/pdf',
  doc: 'application/msword',
  docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  ppt: 'application/vnd.ms-powerpoint',
  pptx: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  msg: 'application/vnd.ms-outlook',
  // 音频
  mp3: 'audio/mp3',
  mpeg: 'audio/mpeg',
  wav: 'audio/wav',
  aac: 'audio/aac',
  ogg: 'audio/ogg',
  webm: 'audio/webm',
  m4a: 'audio/m4a',
  wma: 'audio/wma',
  'x-m4a': 'audio/x-m4a',
  'x-ms-wma': 'audio/x-ms-wma',
  amr: 'audio/amr',
  flac: 'audio/flac',
  // 视频
  mp4: 'video/mp4',
  avi: 'video/avi',
  'x-avi': 'video/x-msvideo',
  mov: 'video/quicktime',
  flv: 'video/x-flv',
  wmv: 'video/x-ms-wmv',
  'v-webm': 'video/webm',
  'v-ogg': 'video/ogg',
  'x-msvideo': 'video/x-msvideo',
  'x-mpeg': 'video/mpeg',
  'x-matroska': 'video/x-matroska',
  'x-ms-asf': 'video/x-ms-asf',

  zip: 'application/zip',
  rar: 'application/x-rar-compressed',
  csv: 'text/csv',
}

export const FileIconMap: Record<string, string> = {
  pdf: PDF,
  xlsx: EXCEL,
  md: MD,
  docx: WORD,
  doc: WORD,
  txt: TEXT,
  html: HTML,
  zip: ZIP,
  book: BOOK,
  jpg: IMAGE,
  jpeg: IMAGE,
  png: IMAGE,
  ppt: PPT,
  pptx: PPT,
  msg: EMAIL,

  mp3: AUDIO,
  mpeg: AUDIO,
  wav: AUDIO,
  aac: AUDIO,
  ogg: AUDIO,
  webm: AUDIO,
  m4a: AUDIO,
  wma: AUDIO,
  'x-m4a': AUDIO,
  'x-ms-wma': AUDIO,
  amr: AUDIO,
  flac: AUDIO,
  mp4: VIDEO,
  flv: VIDEO,
  wmv: VIDEO,
  mov: VIDEO,
  avi: VIDEO,
  'x-avi': VIDEO,
  'v-webm': VIDEO,
  'v-ogg': VIDEO,
  'x-msvideo': VIDEO,
  'x-mpeg': VIDEO,
  'x-matroska': VIDEO,
  'x-ms-asf': VIDEO,
}

export const FileTypeIconMap = {
  QA: QAIcon,
}

/**
 *
 * @description 根据mimetype获取文件类型
 * @param mimeType
 * @returns docx | pdf | txt | md | xlsx
 */
export function getFileSuffixByMime(mimeType: string): string | undefined {
  const map = invert(fileTypeMimeMap)
  return map[mimeType]
}

export function getFileIconByMimetype(mimetype: string) {
  const type = getFileSuffixByMime(mimetype)
  return FileIconMap[type || 'text'] ?? FileIconMap.text
}

// 扩展兼容FileType的icon逻辑
export function getFileIconByFileTypeOrMimeType(
  mimetype: string,
  fileType?: DocumentType,
) {
  return fileType === DocumentType.QA
    ? FileTypeIconMap.QA
    : getFileIconByMimetype(mimetype)
}
